/**
 * Types for the Render Picker feature
 * Allows selecting existing renders as image source
 */

/**
 * Simplified render item for the picker UI
 */
export interface RenderPickerItem {
  id: string;
  imageUrl: string;
  conceptName: string | null;
  projectName: string | null;
  isFavorite: boolean;
  isUpscaled: boolean;
  createdAt: string;
  conceptId: string;
  projectId: string;
}

/**
 * State for the render picker
 */
export interface RenderPickerState {
  renders: RenderPickerItem[];
  isLoading: boolean;
  isLoadingMore: boolean;
  favoritesOnly: boolean;
  hasMore: boolean;
  currentPage: number;
  error: string | null;
  downloadingRenderId: string | null;
}

/**
 * Media source options for unified upload
 */
export type MediaSource = 'files' | 'renders';

/**
 * Configuration for media source selector
 */
export interface MediaSourceConfig {
  /** Allow selecting from renders */
  showRendersOption?: boolean;
  /** Allow selecting multiple files */
  allowMultiple?: boolean;
  /** Maximum number of files to select */
  maxFiles?: number;
  /** Accepted file types */
  accept?: string;
  /** Title for the selector dialog */
  title?: string;
  /** Subtitle/description for the selector dialog */
  subtitle?: string;
}

/**
 * Page size for render picker pagination
 */
export const RENDER_PICKER_PAGE_SIZE = 20;
